import "./intro.css";

import { FaAward } from "react-icons/fa";
import React from "react";
import { VscFolderLibrary } from "react-icons/vsc";
import img from '../../assets/p.png'

// import ME from '../../assets/Rasif Tagizade image.jpg';


const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={img} alt="Rasif Taghizade" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1+ year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p>
          I’m Mandip Chaudhary, a Front-End Developer skilled in React.js, Next.js, 
          Tailwind, and modern web technologies. With a strong foundation
           in IT from Phoenix College of Management, I focus on building clean, user-friendly 
           digital experiences.  <br />

          Recognized as 1st Runner-Up in the Fin-Tech Hackathon and Honorable Mention at the Himal
           AI Hackathon, I continuously push myself to learn and innovate. Alongside technical
            expertise, I bring adaptability, reliability, and effective time management to every project I work on.

          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
